import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Row, Table, Radio } from 'antd';
import generatePath from '~settings/routing';
import formatPrice from '~helpers/currency';
import { communicationStatus } from '~client/constants';
import { allPaymentMethod } from '~constants/landlord';
import RefundModal from '~pages/dashboard/billing/refund/modal';
import { refundStatus, refundFromTypes } from '~constants/landlord';
import { dayFormatType, formatDay } from '~helpers/day';
import { bookingJourneyType } from 'common/constants/booking';
import RejectModal from './reject-modal';

@withTranslation()
export default class RefundTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentType: 'all',
    };
  }
  getColumns = () => {
    const { t } = this.props;
    const columns = [
      {
        title: t('cms.billing.refund.table.refund_number.field'),
        dataIndex: 'id',
        key: 'id',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.referenceId ? record.node.referenceId : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.refund.table.refund_type.field'),
        dataIndex: 'type',
        key: 'type',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.refundType
              ? t(`cms.billing.refund.table.refund_type.${record.node.refundType.toLowerCase()}`)
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.refund.table.refund_method.field'),
        dataIndex: 'method',
        key: 'method',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.refundMethod
              ? t(
                  `cms.billing.refund.table.refund_method.${record.node.refundMethod.toLowerCase()}`,
                )
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.refund.table.refund_status.field'),
        dataIndex: 'status',
        key: 'status',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.status
              ? t(`cms.billing.refund.table.refund_status.${record.node.status.toLowerCase()}`)
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.receive.table.landlord.field'),
        dataIndex: 'landlord',
        key: 'landlord',
        width: '185px',
        render: (text, record) => (
          <div className="receive__table-field">
            {record.node.landlord ? record.node.landlord.name : '-'}
          </div>
        ),
      },
      {
        title: t('cms.billing.receive.table.property.field'),
        dataIndex: 'property',
        key: 'property',
        width: '185px',
        render: (text, record) => (
          <span className="receive__table-field">
            {record.node.order && record.node.order.property
              ? record.node.order.property.name
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.transfer.table.booking_number.field'),
        dataIndex: 'bookingNumber',
        key: 'bookingNumber',
        width: '185px',
        render: (text, record) => (
          <div className="transfer__table-field">
            {record.node.order ? record.node.order.referenceId : '-'}
          </div>
        ),
      },
      {
        title: t('cms.billing.refund.table.refund_amount.field'),
        dataIndex: 'amount',
        key: 'amount',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.amount ? formatPrice(record.node.amount, record.node.currency) : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.refund.table.refund_from.field'),
        dataIndex: 'refundFrom',
        key: 'refundFrom',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.refundFrom
              ? t(`cms.billing.refund.table.refund_from.${record.node.refundFrom.toLowerCase()}`)
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.refund.table.refund_to.field'),
        dataIndex: 'refundTo',
        key: 'refundTo',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.refundTo
              ? t(`cms.billing.refund.table.refund_to.${record.node.refundTo.toLowerCase()}`)
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.refund.table.refund_at.field'),
        dataIndex: 'refundedAt',
        key: 'refundedAt',
        width: '185px',
        render: (text, record) => (
          <span className="refund__table-field">
            {record.node.refundedAt
              ? formatDay(dayFormatType.UKFORMAT, record.node.refundedAt)
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.billing.refund.table.action.field'),
        key: 'action',
        fixed: 'right',
        className: 'refund__action',
        render: (text, record) => {
          const paymentMethodIsStripe = record.node.refundMethod === allPaymentMethod.STRIPE;
          const refundIsPending =
            record.node.status === refundStatus.PENDING_REFUND &&
            record.node.refundFrom === refundFromTypes.STCOM;
          const apIsPending =
            paymentMethodIsStripe &&
            refundStatus.PENDING_REFUND === record.node.status &&
            record.node.refundFrom === refundFromTypes.ACCOMMODATION_PARTNER;
          const apIsConfirmation =
            !paymentMethodIsStripe &&
            refundStatus.REFUND_CONFIRMATION === record.node.status &&
            record.node.refundFrom === refundFromTypes.ACCOMMODATION_PARTNER;

          let modalType;

          if (apIsPending) {
            modalType = 'refund';
          } else if (refundIsPending) {
            modalType = 'refunded';
          } else if (apIsConfirmation) {
            modalType = 'confirm';
          }

          return (
            <Row
              className={classNames('refund__action-row', {
                'refund__action-row--btns':
                  (record.node.status === refundStatus.PENDING_REFUND &&
                    record.node.refundFrom === refundFromTypes.STCOM) ||
                  (record.node.status === refundStatus.REFUND_CONFIRMATION &&
                    record.node.refundFrom === refundFromTypes.ACCOMMODATION_PARTNER),
              })}
            >
              <button
                className="refund__table-btn"
                onClick={() => {
                  this.handleViewBtn(record.node.referenceId);
                }}
              >
                {t('cms.billing.transfer.table.action.view.btn')}
              </button>
              <If condition={refundIsPending || apIsPending || apIsConfirmation}>
                <RefundModal
                  t={t}
                  modalType={modalType}
                  onConfirm={() => {
                    this.props.updateRefundStatus(modalType, record.node.id);
                  }}
                  communication={this.props.communication}
                  type="tableBtn"
                  refundDetails={record.node}
                />
              </If>

              <If
                condition={
                  record.node.refundType === 'DEPOSIT' &&
                  record.node.status === refundStatus.PENDING_REFUND &&
                  ((record.node.refundFrom === refundFromTypes.STCOM &&
                    !record.node.isTransferred) ||
                    (record.node.refundMethod === allPaymentMethod.STRIPE &&
                      record.node.refundFrom === refundFromTypes.ACCOMMODATION_PARTNER))
                }
              >
                <RejectModal
                  t={t}
                  refundDetails={record.node}
                  modalType={modalType}
                  type="tableBtn"
                  onSuccess={this.props.refreshTable}
                />
              </If>
            </Row>
          );
        },
      },
    ];

    return columns;
  };

  handleViewBtn = id => {
    this.props.history.push(generatePath('billing.refundDetail', { id }));
  };

  handleSetRadioValue = e => {
    const value = e?.target?.value;
    this.setState({
      currentType: value,
    });
    this.props.handleTabChange(value);
  };

  render() {
    const { t, list, communication } = this.props;
    const { currentType } = this.state;
    return (
      <div className="refund__table-content">
        <div className="refund__table-header-container">
          <Radio.Group onChange={this.handleSetRadioValue} value={currentType}>
            <Radio.Button value="all">
              {t('cms.properties.edit.rooms.filter.updated_time.all')}
            </Radio.Button>
            <Radio.Button value={bookingJourneyType.SEMI_AUTOMATIC}>
              {t('properties_booking_type_semi_automatic')}
            </Radio.Button>
            <Radio.Button value={bookingJourneyType.INSTANT_BOOK}>
              {t('properties_booking_type_instant_book')}
            </Radio.Button>
          </Radio.Group>
          <h4 className="refund__table-tltle">
            {t('cms.billing.transfer.table.total_title', { totalCount: list.total || 0 })}
          </h4>
        </div>
        <Table
          className="refund__table"
          columns={this.getColumns()}
          dataSource={list.payload || []}
          loading={
            communication &&
            communication.refundList &&
            communication.refundList.status === communicationStatus.FETCHING
          }
          pagination={{
            current: this.props.filters.pageNumber,
            pageSize: this.props.filters.pageSize,
            showSizeChanger: true,
            hideOnSinglePage: false,
            total: list.total,
            onChange: this.props.handlePaginationChange,
            onShowSizeChange: this.props.handlePageSizeChange,
          }}
        />
      </div>
    );
  }
}

RefundTable.propTypes = {
  t: PropTypes.func.isRequired,
  list: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  communication: PropTypes.object,
  filters: PropTypes.object,
  handlePaginationChange: PropTypes.func,
  handlePageSizeChange: PropTypes.func,
  updateRefundStatus: PropTypes.func,
  handleTabChange: PropTypes.func,
};

RefundTable.defaultProps = {
  t: () => {},
  list: {},
  history: {
    push: () => {},
  },
  communication: {},
  filters: {},
  handlePaginationChange: () => {},
  handlePageSizeChange: () => {},
  updateRefundStatus: () => {},
  handleTabChange: () => {},
};
